/** Hex values for the platform brand palette. Used for documentation and design tokens. */
export const BRAND_COLORS = {
  primary: '#606c38',
  dark: '#283618',
  background: '#fefae0',
  accent: '#dda15e',
  highlight: '#bc6c25',
} as const;

/**
 * HSL component strings (without hsl() wrapper) for the brand palette.
 * These are the values written into CSS custom properties in index.css.
 * Tenants can override these at runtime by setting their own HSL values.
 */
export const BRAND_COLORS_HSL = {
  primary: '74 32% 32%',
  primaryDark: '88 39% 15%',
  background: '52 91% 94%',
  accent: '31 63% 62%',
  highlight: '28 67% 44%',
} as const;

/** CSS variable names that can be overridden by a tenant theme. */
export const OVERRIDABLE_THEME_VARS = ['--primary', '--accent', '--ring'] as const;

export type OverridableThemeVar = (typeof OVERRIDABLE_THEME_VARS)[number];
